import { Button, Card, makeStyles } from '@material-ui/core';
import { BodyL, BodyS, HeadingXSBold, HeadingXLBold } from 'components/Typography/Typography';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/services/MicroBundle/planCardStyle';
import { SERVICES, plansColumn } from '../constants';
import { dynamicTranslate, translate } from 'components/Translation';
import { TagManager } from 'commons/gtm/tagManager';
import { getLanguage } from 'utils/language/language';
import { useSelector } from 'react-redux';
import { getAamaliPlusLabels } from 'redux/modules/dynamicLabels/selectors';

//we are getting the substring as everything after mb.plans.column- we are getting from the HCL commerce API and we've added translations for those. While mb.plans.column is being used in other places
const planDetailsKeys = plansColumn.map((col) => col.substring('mb.plans.column-'.length));

interface IMBPlan {
	planDetails: types.ecommerce.PlanDetails;
	setSelectedOption: Function;
	index: number;
	setIndex: Function;
	isHovered: boolean;
	onMouseOver: () => void;
}

// @ts-ignore
const useStyles = makeStyles(styles);
export const PlanCard = ({ planDetails, setSelectedOption, index, setIndex, isHovered, onMouseOver }: IMBPlan) => {
	const classes = useStyles();
	const aamaliPlusLabels = useSelector(getAamaliPlusLabels);

	const setPlan = () => {
		setSelectedOption({
			name: planDetails?.downloadSpeed,
			uniqueID: planDetails?.uniqueID,
			price: planDetails?.price,
			partNumber: planDetails?.partNumber,
			displayName: planDetails?.name,
			discount: planDetails?.discount,
		});
	};
	const handleClick = () => {
		setPlan();
		setIndex(index + 1);
		TagManager.dataLayer({
			dataLayer: {
				event: 'Plan Select Step',
				step: `Plan selected: ${planDetails?.name}`,
				language: getLanguage(),
			},
		});
	};

	const isDiscountAvailable = planDetails?.discount?.match(/[1-9]/);

	return (
		<>
			<div className={isHovered ? classes.cardHover : classes.planCardWrapper} onMouseOver={onMouseOver}>
				{isDiscountAvailable && (
					<div className={classes.discountWrapper}>
						<BodyS customClassName={classes.discountBanner}>{planDetails.discount}</BodyS>
					</div>
				)}
				<Card className={classes.plancard}>
					<HeadingXLBold disableMargin>{`${translate('mb.aamali.plus')}`}</HeadingXLBold>
					<BodyL>{`${translate('prefix.download.speed', planDetails?.downloadSpeed || '')}`}</BodyL>
					<div className={classes.priceWrapper}>
						<HeadingXSBold>
							{translate(
								isDiscountAvailable
									? 'add.new.aamali.plus.price.with.start'
									: 'add.new.aamali.plus.price',
								isDiscountAvailable ? planDetails?.price : planDetails?.offerPrice
							)}
						</HeadingXSBold>
						{isDiscountAvailable && (
							<BodyS customClassName={classes.originalPrice}>
								{translate('add.new.aamali.plus.cut.price', planDetails?.offerPrice)}
							</BodyS>
						)}
					</div>
					<BodyS disableMargin customClassName={classes.contract}>
						{planDetails?.services[SERVICES.CONTRACT]}
					</BodyS>
				</Card>
				<div className={classes.services}>
					<ul>
						{planDetailsKeys?.map((key, i) => {
							if (planDetails?.services[key]) {
								switch (key) {
									case SERVICES.MOBILE_PBX:
									case SERVICES.WEB_HOSTING:
									case SERVICES.MICROSOFT:
										return (
											<li>
												<BodyS>{aamaliPlusLabels[key]}</BodyS>
											</li>
										);
								}
							}
							return (
								<li>
									<BodyS>{dynamicTranslate(aamaliPlusLabels[key], planDetails?.services[key])}</BodyS>
								</li>
							);
						})}
					</ul>
				</div>
				<Card className={classes.buttonCard}>
					<Button
						variant="contained"
						color="primary"
						size="small"
						fullWidth={true}
						className={classes.selectButton}
						onClick={handleClick}
						aria-label={translate('mb.select.button') + ' ' + planDetails.name}
					>
						{translate('mb.select.button')}
					</Button>
				</Card>
			</div>
		</>
	);
};
